export { DtvMediaModal as default } from "./dtv-media-modal";
